import { Card, CardContent } from "@/components/ui/card";

const WEEKDAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

const CalendarGrid = ({
  year,
  month,
  monthStr,
  daysInMonth,
  firstDayOfWeek,
  selectedDate,
  appointments,
  reminders,
  onSelectDate,
  onDoubleClick
}) => {
  const getAppointmentsForDay = (day) => {
    const date = `${monthStr}-${String(day).padStart(2, "0")}`;
    return appointments.filter(a => a.date === date);
  };

  const getRemindersForDay = (day) => {
    const date = `${monthStr}-${String(day).padStart(2, "0")}`;
    return reminders.filter(r => r.datetime_iso && r.datetime_iso.startsWith(date));
  };

  return (
    <Card className="lg:col-span-2 border border-border shadow-sm rounded-sm" data-testid="appointment-calendar">
      <CardContent className="p-3 sm:p-6">
        {/* Weekday headers */}
        <div className="grid grid-cols-7 gap-1 sm:gap-2 mb-2 sm:mb-4">
          {WEEKDAYS.map(day => (
            <div key={day} className="text-center text-[10px] sm:text-xs font-medium text-muted-foreground py-1 sm:py-2">
              {day}
            </div>
          ))}
        </div>

        {/* Calendar grid */}
        <div className="grid grid-cols-7 gap-1 sm:gap-2">
          {/* Empty cells */}
          {Array.from({ length: firstDayOfWeek }).map((_, i) => (
            <div key={`empty-${i}`} className="aspect-square"></div>
          ))}

          {/* Days */}
          {Array.from({ length: daysInMonth }, (_, i) => i + 1).map(day => {
            const date = `${monthStr}-${String(day).padStart(2, "0")}`;
            const dayApts = getAppointmentsForDay(day);
            const dayReminders = getRemindersForDay(day);
            const isSelected = date === selectedDate;
            const isToday = date === new Date().toISOString().split("T")[0];
            const hasItems = dayApts.length > 0 || dayReminders.length > 0;

            return (
              <button
                key={day}
                onClick={() => onSelectDate(date)}
                onDoubleClick={() => onDoubleClick(date)}
                className={`
                  aspect-square rounded-sm border-2 flex flex-col items-center justify-start p-0.5 sm:p-1 transition-all
                  ${isSelected ? "ring-2 ring-foreground ring-offset-1 sm:ring-offset-2" : ""}
                  ${isToday ? "border-foreground" : "border-border"}
                  ${hasItems ? "bg-muted" : "bg-background hover:bg-muted/50"}
                `}
                data-testid={`calendar-day-${day}`}
              >
                <span className={`text-[10px] sm:text-xs font-mono ${isToday ? "font-bold" : ""}`}>{day}</span>
                <div className="flex flex-wrap gap-0.5 mt-0.5 justify-center">
                  {dayApts.slice(0, 2).map((_, i) => (
                    <div key={`apt-${i}`} className="w-1 h-1 sm:w-1.5 sm:h-1.5 rounded-full bg-foreground" />
                  ))}
                  {dayReminders.slice(0, 2).map((_, i) => (
                    <div key={`rem-${i}`} className="w-1 h-1 sm:w-1.5 sm:h-1.5 rounded-full bg-orange-500" />
                  ))}
                  {(dayApts.length + dayReminders.length) > 4 && (
                    <span className="text-[6px] sm:text-[8px] text-muted-foreground">+</span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
        
        {/* Legend */}
        <div className="flex justify-center gap-4 mt-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 rounded-full bg-foreground"></div>
            <span>Appuntamento</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 rounded-full bg-orange-500"></div>
            <span>Promemoria</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CalendarGrid;
